// created by T A C Priyashad at 20210723 22:39.
// 
// myPOS Software Solutions (pvt) Ltd.
// myPOS Framework.
// React JS.

import React, { useState } from 'react'
import DPToolBar from '../widgets/DPToolBar';

const DPTopToolBar = (props) => {

    const btnList = [
        {
            btnText: "Help",
            btnIcon: "help-circle",
            btnColor: "info",
            btnEnable: props.helpEnable,
            btnDisplay: props.helpDisplay,
            onClick: props.helpClick,
            title: "Help Information"
        },
        {
            btnText: "Favorite",
            btnIcon: "star",
            btnColor: "light",
            btnEnable: props.favoriteEnable,
            btnDisplay: props.favoriteDisplay,
            onClick: props.favoriteClick,
            title: "Add to Favorite List"
        },
        {
            btnText: "Refresh",
            btnIcon: "autorenew mdi-spin",
            btnColor: "primary",
            btnEnable: props.newEnable,
            btnDisplay: props.newDisplay,
            onClick: props.newClick,
            title: "Refresh Form"
        },
        {
            btnText: "Save",
            btnIcon: "content-save",
            btnColor: "success",
            btnEnable: props.saveEnable,
            btnDisplay: props.saveDisplay,
            onClick: props.saveClick,
            title: "Save or Update Record"
        },
        {
            btnText: "Process",
            btnIcon: "file-sync",
            btnColor: "secondary",
            btnEnable: props.processEnable,
            btnDisplay: props.processDisplay,
            onClick: props.processClick,
            title: "Process Record"
        },
        {
            btnText: "Edit",
            btnIcon: "pencil",
            btnColor: "warning",
            btnEnable: props.editEnable,
            btnDisplay: props.editDisplay,
            onClick: props.editClick,
            title: "Edit Record"
        },
        {
            btnText: "Print",
            btnIcon: "printer",
            btnColor: "primary",
            btnEnable: props.printEnable,
            btnDisplay: props.printDisplay,
            onClick: props.printClick,
            title: "Print Record"
        },
        {
            btnText: props.deleteTitle ?? "Delete",
            btnIcon: "trash-can",
            btnColor: "danger",
            btnEnable: props.deleteEnable,
            btnDisplay: props.deleteDisplay,
            onClick: props.deleteClick,
            title: "Delete Record"
        },
        {
            btnText: "Exit",
            btnIcon: "power",
            btnColor: "dark",
            btnEnable: props.exitEnable,
            btnDisplay: props.exitDisplay,
            onClick: props.exitClick,
            title: "Go Back to Dashboard"
        }
    ];

    return (
        <div style={{ paddingBottom: "10px" }}>
            <DPToolBar
                buttons={btnList}
                //btnSize={"lg"}
                btnWidth={"sm"}
                iconFont={"18"}
                menuStyle={"btn-group"}
            />
        </div>
    );

}

export default DPTopToolBar;